export default __webpack_public_path__ + "static/media/event_placeholder_image.5bf3dc3c.svg";